import _ from 'lodash';

const FREE_TRIAL_VARIANT = 'trial';
const DISCOUNT_VARIANT = 'discount';
const PROMO_CODE = 'dormant-winback';

// The trial and discount variants grant their own benefit as part of the reset; every other
// variant resets without one.
function promoCodeForVariant(variant) {
  if (variant === FREE_TRIAL_VARIANT) {
    return FREE_TRIAL_VARIANT;
  }
  if (variant === DISCOUNT_VARIANT) {
    return PROMO_CODE;
  }
  return undefined;
}

// The trial variant got a fresh trial and goes back through the state router into the app;
// everyone else continues straight to payment, except redesign customers, who go back to the app
// (elsa-v3) and reach payment from its dormant screen. fromDormantReset marks the reset as done, so
// the winback guards stop redirecting and the subscription flow knows to wait for the scrape. The
// promo code is dropped once granted so a later navigation cannot try to grant it twice.
function destinationForVariant(variant, query = {}, { redesign = false } = {}) {
  return {
    path: variant === FREE_TRIAL_VARIANT || redesign ? '/sr' : '/subscription',
    query: { ..._.omit(query, 'promoCode'), fromDormantReset: 'true' },
  };
}

export default {
  FREE_TRIAL_VARIANT,
  DISCOUNT_VARIANT,
  PROMO_CODE,
  promoCodeForVariant,
  destinationForVariant,
};
